import styled, { css } from 'styled-components'

import { settingsTypes } from '@/configuration/constants'

export const Container = styled.div`
  display: grid;
  grid-template-columns: 7fr 3fr;
  align-items: center;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp12};
  border-radius: ${props => props.theme.primitives.radius.radius1};

  ${props =>
    props.type === settingsTypes.global &&
    css`
      background-color: ${props.theme.colors.success.surface};
      border: ${props => props.theme.stroke.default} solid ${props.theme.colors.background.decorative};
      color: ${props.theme.colors.success.hover};
    `}

  ${props =>
    props.type === settingsTypes.custom &&
    css`
      background-color: ${props.theme.colors.info.surface};
      border: ${props => props.theme.stroke.default} solid ${props.theme.colors.info.default};
      color: ${props.theme.colors.info.onSurface};
    `}
`
